// Business form validation utilities
export const validateBusinessForm = (form: any) => {
  const errors: string[] = [];
  
  if (!form.name?.trim()) {
    errors.push("Business name is required");
  }
  
  if (!form.contact_email?.trim()) {
    errors.push("Contact email is required");
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.contact_email)) {
    errors.push("Please enter a valid email address");
  }
  
  if (form.contact_phone && !/^[\+]?[0-9\s\-\(\)]{10,}$/.test(form.contact_phone.replace(/\s/g, ''))) {
    errors.push("Please enter a valid phone number");
  }
  
  return errors;
};

export const validateFileUpload = (
  file: File, 
  maxSizeMB: number = 5, 
  allowedTypes: string[] = ['image/jpeg', 'image/png', 'image/webp']
) => {
  const errors: string[] = [];
  
  if (file.size > maxSizeMB * 1024 * 1024) {
    errors.push(`File size must be less than ${maxSizeMB}MB`);
  }
  
  if (!allowedTypes.includes(file.type)) {
    errors.push(`File type must be one of: ${allowedTypes.join(', ')}`);
  }
  
  return errors;
};

// Enhanced error handling utility
export const handleError = (error: any, defaultMessage: string = "An unexpected error occurred") => {
  console.error('Dashboard Error:', error);
  
  if (error?.message) {
    return error.message;
  }
  
  if (typeof error === 'string') {
    return error;
  }
  
  return defaultMessage;
};